import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGE } from "../constants/page";
import "../../src/styles/ViewPatientDetails.scss";
import { Button, Alert } from "react-bootstrap";
import { API } from "../constants/api";
import Utility from "../utility/Utility";
import Breadcrumbs from "../components/Breadcrumbs";
import { useAppDispatch } from "../redux/hooks";
import { ApiCallWithLoader, errorUpdate } from "../redux/reducers/LoaderSlice";
import { Trans } from "react-i18next";
import { updatedPatient } from "../redux/reducers/PatientSlice";
import { updateScreeningStatus } from "src/redux/reducers/ScreeningSlice";

const ViewPatientDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const patientId: string = location.pathname.split("/").pop() || "";
  const [patientDetails, setPatientDetails] = useState<any>(null);
  const dispatch = useAppDispatch();

  const handleBrowserBackButton = (e: any) => {
    window.removeEventListener("popstate", handleBrowserBackButton, false);
    navigate(PAGE.HOME);
  };

  useEffect(() => {
    dispatch(updateScreeningStatus({ screening: false, loaded: false }));
    window.removeEventListener("popstate", handleBrowserBackButton, false);
    window.addEventListener("popstate", handleBrowserBackButton, false);
    window.scrollTo(0, 0);
    const fetchUserDetails = async () => {
      const requestDetails = {
        url: API.PATIENT_DETAILS.replace(":id", patientId),
        method: "GET",
      };
      try {
        const resp = await dispatch(ApiCallWithLoader(requestDetails));
        setPatientDetails(resp.payload);
      } catch (error) {
        dispatch(errorUpdate({ isError: true, error: error }));
      }
      //return true;
    };
    fetchUserDetails();

    return () => {
      window.removeEventListener("popstate", handleBrowserBackButton, false);
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const navigateToViewDetails = () => {
    navigate(PAGE.VIEW_PATIENT.replace(":id", patientId));
    dispatch(updatedPatient(false));
  };

  const startScreening = () => {
    /**
     * isBackButtonClicked is getting used in screening page
     * to overite back button behaviour
     */
    localStorage.setItem("startScreening", "1");
    navigate(PAGE.SCREENING_IFRAME, {
      state: { patientDetails: patientDetails },
    });
  };

  return (
    <>
      {patientDetails && (
        <>
          <Breadcrumbs
            active_key={Utility.patientName(patientDetails?.name)}
            navigation={navigate}
            location={location.pathname}
          />
          <div className="container">
            <div className="viewPatientDetails ">
              <div className="patientCard borderTop p-3 pb-0 m-auto">
                <div className="row pb-2">
                  <div className="col-md-12" style={{ position: "relative" }}>
                    <div className="row pb-2">
                      <div className="col-3 col-md-2">
                        <div className="d-inline-block p-3 user-icon">
                          <img
                            src={`/icons/${
                              patientDetails?.gender || "male"
                            }.svg`}
                            alt=""
                          />
                        </div>
                      </div>

                      <div className="col-9 col-md-10 alignRight">
                        <span className="patientDeatilsBoldSm">
                          <Trans
                            i18nKey={Utility.getIDString(patientDetails)}
                          ></Trans>{" "}
                          -{" "}
                          {Utility.getIDNumber(patientDetails) ===
                          "unavailable" ? (
                            <Trans i18nKey={"unavailable"}></Trans>
                          ) : (
                            Utility.getIDNumber(patientDetails)
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="row pb-2">
                      <div className="col-12">
                        <h5 className="patientDeatilsBold pt-2 text-capitalize">
                          {Utility.patientName(patientDetails?.name)}
                        </h5>
                        <span className="patientDeatilsReg">
                          <span className="pe-2">
                            {Utility.getAge(patientDetails?.birthDate)}{" "}
                          </span>
                          <br></br>
                          <span className={patientDetails?.gender}>
                            <span className="text-caps pe-2">
                              {patientDetails?.gender ? (
                                <Trans i18nKey={patientDetails?.gender}></Trans>
                              ) : (
                                <Trans i18nKey={"unavailable"} />
                              )}
                            </span>
                          </span>
                          |
                          <span className="ps-2">
                            <Trans i18nKey={"dob"}></Trans> :{" "}
                            {Utility.formatDate(patientDetails?.birthDate) || (
                              <Trans i18nKey={"unavailable"} />
                            )}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="patientCard borderBtm p-3 pt-0 m-auto">
                <div className="justifyItems " style={{ marginTop: "11px" }}>
                  <div>
                    <div className="patientDeatilsBold">
                      <img src="/icons/contact.svg" alt="" />{" "}
                      <span>
                        {patientDetails?.telecom ? (
                          patientDetails?.telecom[0]?.value
                        ) : (
                          <Trans i18nKey={"unavailable"} />
                        )}
                      </span>
                    </div>
                  </div>
                  <div>
                    <Button
                      className="btn-outline"
                      onClick={navigateToViewDetails}
                    >
                      <Trans i18nKey={"view_profile"}></Trans>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="other-options mt-3">
                <div className="option" onClick={startScreening}>
                  <span>
                    <Trans i18nKey={"start_screening"}></Trans>
                  </span>
                  <span className="text-end">
                    <img src="/icons/forward-icon-blue.svg" alt="" />
                  </span>
                </div>
              </div>
            </div>
            <div className="m-auto empty-elem-to-handle-zoom-in">
              {/* 
                do not remove this empty div its added to avoid footer overlapping when zoomIn
                this DIV should be always position at the end of this page
              */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ViewPatientDetails;
